import React, { Component } from 'react';
import { Image, Col, Row, Container } from 'react-bootstrap';
import CelPortafolio2 from '../../../img/NewPNG/new-wb-franja-app-english.svg';
import Cohetito2 from '../../../img/NewPNG/FranjaApp_Rocket2.png';
import CelPortafolio from '../../../img/NewPNG/new-wb-franja-app.svg';
import Cohetito from '../../../img/NewPNG/FranjaApp_Rocket.png';
import AppStore from '../../../img/LogoAppstore2.png';
import PlayStore from '../../../img/LogoGoogle2.png';
import Translate from '../../../../../translate';
import './index.css';

class DescargaApp extends Component {
    constructor(props) {
        super(props);
        this.state = { 
          
         }
    }
    render() {
        return (
          <div className='appBackground section-container app' id='descarga'>
              <div className='descargaImgDiv'>
                <Image src={this.props.lan === 'es' ? CelPortafolio : CelPortafolio2} className='portfolio-img' />
                <Image src={this.props.lan === 'es' ? Cohetito : Cohetito2} className='portfolio-rocket' />
              </div>
            <Container>
                <Row className="elRowDeLaApp">
                    <Col md={12} lg={6} style={{textAlign:'right'}}>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className='descargapp-container'>
                          <p className='descargapp-title'>{Translate[this.props.lan].landing3.seccion7.titulo}
                            <br/>
                            <span className='descargapp-subtitle'>{Translate[this.props.lan].landing3.seccion7.subtitulo}</span>
                          </p>
                          <Row style={{marginTop:15, marginLeft:0}}>
                            <a  href="https://apps.apple.com/mx/app/wirebit-digital/id1563970813" target='_blank'> <Image src={AppStore} className='appstoreIconStyle appstoreIconStyle2'/></a>
                            <a style={{cursor:'pointer'}} href="https://play.google.com/store/apps/details?id=com.wirebitdigitalapp" target='_blank' > <Image src={PlayStore} className='appstoreIconStyle' /></a>
                          </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
          </div>
        );
    }
}

export default DescargaApp;
